const levenshtein = require('js-levenshtein');

// generated using https://gitlab.com/leomedia-gmbh/leoticket/wertstoff/mxcheck_poc/-/tree/main/utils/extract_topdomains.py + filtered manually
const knownMX = ['gmx.de', 'gmx.com', 'gmx.net', 'gmx.at', 'gmx.ch', 'gmail.com', 'Gmail.com', 't-online.de', 'yahoo.de', 'yahoo.com',
	'googlemail.com', 'freenet.de', 'aol.com', 'aol.de', 'hotmail.de', 'hotmail.com', 'leomedia.de', 'arcor.de', 'icloud.com', 'wtnet.de',
	'online.de', 'outlook.de', 'outlook.com', 'posteo.de', 'live.de', 'live.com', 'kabelmail.de', 'me.com', 'mail.de', 'htp-tel.de', 'teleos-web.de',
	'ewetel.net', 'email.de', 'unitybox.de', 'kabelbw.de', 'ewe.net', 'nord-com.net', 'onlinehome.de', 'mailbox.org', 'vodafone.de',
	'vodafonemail.de', 'web.de', 'o2mail.de', 'o2online.de', 'alice-dsl.net', 'ymail.com', 'msn.com', 'mac.com', 'magenta.de', 'netcologne.de',
	'snafu.de'];

/*function checkFormat(email) {
	// check format of email to be like: "someSigns@someSigns.someSigns"
	if (email.length > 0 && !(/\S+@\S+\.\S+/.test(email))) {
		return 'Bitte korrigieren Sie das Format der E-Mail-Adresse';
	}
	return null;
}*/

async function hasMX(domain) {
	// https://developers.cloudflare.com/1.1.1.1/encryption/dns-over-https
	const answer = await fetch(`https://cloudflare-dns.com/dns-query?${new URLSearchParams({
		name: domain, type: 'MX',
	})}`, {
		headers: { Accept: 'application/dns-json' },
	})
		.then(r => r.json())
		.then(d => 'Answer' in d);
	if (!answer) {
		return 'Die Domain des E-Mail-Servers ist ungültig.';
	}
	return null;
}

function similarMX(domain) {
	const similar = [];
	for (const mx of knownMX) {
		if (levenshtein(mx, domain) <= 2) similar.push(mx);
	}
	if (similar.length > 0 && !similar.includes(domain)) {
		return `${similar.length > 1 ? 'Vorschläge:' : 'Vorschlag:'} ${similar.join(', ')}`;
	}
	return null;
}

async function validate(address) {
	/*const format = checkFormat(address);
	if (format) {
		return format;
	}*/
	const domain = address.split('@')[1];
	const similar = similarMX(domain);
	if (similar) {
		return similar;
	}
	return await hasMX(domain);
}

export default validate;
